{
  "name": "@tuc/tuc-tudirect-gui",
  "version": "1.6.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve -c dev",
    "start-hmr": "ng serve -c dev --hmr",
    "start-es5": "ng serve -c es5",
    "build": "ng build",
    "test": "ng test",
    "lint": "npm run lint-ts && npm run lint-scss",
    "lint-ts": "npx ng lint tuc-tudirect-gui",
    "ng-upgrade-minor": "npx npm-check-updates --upgrade --target \"minor\" --filter \"/@angular.*/\"",
    "lint-scss": "npx stylelint \"**/*.scss\"",
    "e2e": "ng e2e",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "dependencies": {
    "@angular/animations": "^21.1.0",
    "@angular/cdk": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/google-maps": "^21.1.0",
    "@angular/localize": "^21.1.0",
    "@angular/material": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/http-client": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^6.0.0",
    "@techiediaries/ngx-qrcode": "^9.1.0",
    "@types/jquery": "^3.5.33",
    "angularx-qrcode": "^21.0.0",
    "bootstrap": "^5.3.8",
    "core-js": "^3.47.0",
    "flatted": "^3.2.5",
    "google-libphonenumber": "^3.2.43",
    "lodash": "^4.17.21",
    "material-icons": "^1.13.14",
    "moment": "^2.30.1",
    "ngx-mask": "^13.2.2",
    "popper.js": "^1.16.1",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "tsutils": "^3.21.0",
    "whatwg-fetch": "^3.6.20",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/core": "^21.1.0",
    "@angular-eslint/builder": "^21.1.0",
    "@angular-eslint/eslint-plugin": "^21.1.0",
    "@angular-eslint/eslint-plugin-template": "^21.1.0",
    "@angular-eslint/schematics": "^21.1.0",
    "@angular-eslint/template-parser": "^21.1.0",
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@angular/language-service": "^21.1.0",
    "@cypress/schematic": "^1.7.0",
    "@types/jasmine": "^4.6.5",
    "@types/lodash": "^4.17.21",
    "@types/node": "^14.18.63",
    "@typescript-eslint/eslint-plugin": "^7.18.0",
    "@typescript-eslint/parser": "^7.18.0",
    "cypress": "^15.9.0",
    "eslint": "^8.57.1",
    "eslint-plugin-import": "2.25.4",
    "eslint-plugin-jsdoc": "^39.3.3",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-rxjs": "^5.0.3",
    "jasmine-core": "^4.6.1",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.1.1",
    "karma-coverage": "^2.2.0",
    "karma-jasmine": "^5.0.0",
    "karma-jasmine-html-reporter": "^2.0.0",
    "stylelint": "^15.10.2",
    "stylelint-config-sass-guidelines": "^10.0.0",
    "ts-node": "^9.1.1",
    "typescript": "~5.9.3"
  },
  "overrides": {
    "@ng-bootstrap/ng-bootstrap": {
      "rxjs": "^7.5.5"
    },
    "eslint": {
      "ansi-regex": "^5.0.1"
    },
    "eslint-plugin-import": {
      "json5": "^1.0.2"
    },
    "webpack-dev-server": "^5.2.2",
    "http-proxy-middleware": "^2.0.9",
    "form-data": "^2.5.4"
  }
}
